import { render, staticRenderFns } from "./AdminInstitutionGroupsSearch.vue?vue&type=template&id=276816cb&"
import script from "./AdminInstitutionGroupsSearch.vue?vue&type=script&lang=js&"
export * from "./AdminInstitutionGroupsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports